import script from "./WDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./WDialog.vue?vue&type=script&setup=true&lang=js"

import "./WDialog.vue?vue&type=style&index=0&id=07e9e16a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07e9e16a"]])

export default __exports__